module.exports = __webpack_public_path__ + "img/conference11.bb30cd80.jpg";